import { z } from 'zod';
import id from './uuid.dto';

const reference = z.object({
  id,
});

export const namedReference = z.object({
  ...reference.shape,
  name: z.string(),
});

export const optionalNamedReference = z.object({
  ...reference.shape,
  name: z.string().optional(),
});

export default reference;

export type Reference = z.infer<typeof reference>;
export type NamedReference = z.infer<typeof namedReference>;
export type OptionalNamedReference = z.infer<typeof optionalNamedReference>;
